import React, { ChangeEvent } from "react";
import clsx from "clsx";

import MuiCheckbox, { CheckboxProps } from "@material-ui/core/Checkbox";

import useStyles from "./styles";

interface IProps extends CheckboxProps {
  isChecked: boolean;
  value: unknown;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  isSelectAll?: boolean;
  startLabel?: string;
  endLabel?: string;
}

const Checkbox = (props: IProps) => {
  const {
    isChecked,
    value,
    onChange,
    isSelectAll = false,
    startLabel = "",
    endLabel = "",
    className,
    classes: muiClasses
  } = props;

  const classes = useStyles();

  return (
    <label className={clsx(className, classes.root)}>
      {startLabel && (
        <span className={classes.label} data-test-id="checkBoxLabel">
          {startLabel}
        </span>
      )}
      <MuiCheckbox
        className={clsx({ selectAll: isSelectAll })}
        checked={isChecked}
        value={value}
        name={startLabel || endLabel}
        onChange={onChange}
        data-test-id="checkBox"
        classes={{
          root: classes.checkbox,
          colorSecondary: classes.secondaryColor,
          checked: classes.checked,
          ...muiClasses
        }}
      />
      {endLabel && (
        <span className={classes.label} data-test-id="checkBoxLabel">
          {endLabel}
        </span>
      )}
    </label>
  );
};

export default React.memo(Checkbox);
